import { ACTIVITY_TYPES } from 'constants/general';
import { useAppSelectorShallow } from 'store/hooks';
import { moreOptionsAllowedAppsSelector } from 'store/reducer/setting/selectors';
import Applications from './Applications';
import Websites from './Websites';
import MicroBreaks from './MicroBreaks';
import FocusMode from './FocusMode';
import GuiltFreePlay from './GuiltFreePlay';

const AllowedAppsTab: React.FC = () => {
  const { activityType } = useAppSelectorShallow(
    moreOptionsAllowedAppsSelector
  );

  return (
    <div className='w-full flex flex-col ~gap-6/8'>
      <Applications />
      <Websites />
      {activityType !== ACTIVITY_TYPES.BREAKING && <MicroBreaks />}
      <div className='grid grid-cols-1 sm:grid-cols-2 ~gap-3/6'>
        <FocusMode />
        <GuiltFreePlay />
      </div>
    </div>
  );
};

export default AllowedAppsTab;
